import React from "react";
import { useLocation } from "react-router-dom";
import SkillGroup from "./SkillGroup/SkillGroup";
//import ManageSkills from "./ManageSkills/ManageSkills";
import ManageSkillsList from "./SkillSet/ManageSkillList"
import SubSkillList from "./subSkills/subSkillList";

const Skills = () => {
  const location = useLocation();
  if (location.search.includes("groups")) return <SkillGroup />;
  //if (location.search.includes("manage")) return <ManageSkills />;
  //if (location.search.includes("mapping")) return <ManageSkillsList />;
  if (location.search.includes("subSkill")) return <SubSkillList />;
  else return <h1>Select An Option!</h1>;
};
 
export default Skills;
